export default "__VITE_ASSET__CwpgEF9W__"